import { render, staticRenderFns } from "./CreateMindo.vue?vue&type=template&id=1649fde5&"
import script from "./CreateMindo.vue?vue&type=script&lang=js&"
export * from "./CreateMindo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports